import { render, staticRenderFns } from "./XiangMu.vue?vue&type=template&id=20e9db93&scoped=true"
import script from "./XiangMu.vue?vue&type=script&lang=js"
export * from "./XiangMu.vue?vue&type=script&lang=js"
import style0 from "./XiangMu.vue?vue&type=style&index=0&id=20e9db93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9db93",
  null
  
)

export default component.exports